export default __webpack_public_path__ + "static/media/Dialog7.d02bb6d2.svg";